import login from './login'
import enterFor from './enterFor'
import user from './user'
import contribute from './contribute'
import timeManage from './timeManage'
import notice from './notice'
import gameRule from './gameRule'


/**
 * API出口文件
 */
export default {
    login,//登录相关的
    enterFor,//报名
    user,//用户
    contribute,//投稿
    timeManage,//时间管理
    notice,//公告
    gameRule,//处理投稿的阶段
}



// WEBPACK FOOTER //
// ./src/api/index.js